module.exports = __webpack_public_path__ + "img/yanbao_heisexi_foot.d6191e6c.png";